import { render } from "./OuterPasswordCompletePage.vue?vue&type=template&id=b97cd934&scoped=true&ts=true"
import script from "./OuterPasswordCompletePage.vue?vue&type=script&lang=ts"
export * from "./OuterPasswordCompletePage.vue?vue&type=script&lang=ts"

import "./OuterPasswordCompletePage.vue?vue&type=style&index=0&id=b97cd934&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b97cd934"]])

export default __exports__